import 'Styles/searchview.scss';

import React from 'react';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';

import searchResultSelector from 'Selectors/searchResultSelector';

import { fetchSearch } from 'Actions/SearchResultActions';
import { resetInfinite } from 'Actions/InfiniteScrollActions';
import { resetForum } from 'Actions/ForumviewActions';
import { resetThread } from 'Actions/ThreadviewActions';
import { resetSearch } from 'Actions/SearchResultActions';

import {
	checkAdsPermissions,
	resetHiddenAdsPerUser,
	trackPageView,
	onPageView,
	triggerCaptify,
	trackGAEvent
} from 'Actions/adsActions';

import { pathToSearch, pathToActiveTopics, pathToNewPosts, pathToParticipated } from 'Utils/nav/NavHelpers';

import ForumList from 'Components/forums/ForumListComponent';
import ThreadList from 'Components/threads/ThreadListComponent';
import PostList from 'Components/posts/PostListComponent';
import AdComponent from 'Components/ads/AdComponent';
import InfiniteScroll from 'Components/infiniteScroll/InfiniteScrollComponent';
import LoaderCss from 'Components/common/LoaderCssComponent';

class SearchViewComponent extends React.Component {
	constructor(props) {
		super(props);
		this.redirect = false;

		this.state = {
			headerHeight: 0
		};
	}

	componentWillMount() {
		this.props.dispatch( checkAdsPermissions( 0 ) );
		this.props.dispatch( resetHiddenAdsPerUser() );
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.repositionScroll();
		this._resetStore();
		this.dispatchSearch( this.props );
	}

	componentWillUnmount() {
		this._resetStore();
	}

	componentWillReceiveProps( nextProps ) {
		if(
			nextProps.location.query.refresh ||
			nextProps.location.query.q !== this.props.location.query.q ||
			nextProps.location.query.showtopics !== this.props.location.query.showtopics ||
			nextProps.location.query.showposts !== this.props.location.query.showposts ||
			nextProps.location.query.forumid !== this.props.location.query.forumid ||
			( nextProps.route.path !== this.props.route.path && this.redirect === false )
		) {
			this._resetStore();

			window.scrollTo(0, 0);
			nextProps.location.query.page = 1;

			// if we are refreshing (searching again the same term) clear the url
			if( nextProps.location.query.refresh ) {
				let query = nextProps.location.query;
				delete query.refresh;
				this.props.dispatch( replace( {
					pathname: nextProps.location.pathname,
					query: query
				} ) );
			}

			this.dispatchSearch( nextProps );
			this.repositionScroll();

		} else if( nextProps.route.path !== this.props.route.path && this.redirect ) {
			this.redirect = false;
		}

		if( nextProps.searchresult.isFetching === false && this.props.searchresult.isFetching &&
			nextProps.searchresult.loaded && nextProps.searchresult.loaded !== this.props.searchresult.loaded ) {
			// trigger ad updates
			this.props.dispatch( onPageView() );
			// Record the Google Analytics pageview
			this.props.dispatch( trackPageView() );
		}
	}

	componentDidUpdate( prevProps ) {
		if(
			prevProps.searchresult.isFetching &&
			this.props.searchresult.isFetching === false &&
			this.props.searchresult.loaded
		) {
			// Update the URL if we need to
			if( this.props.searchresult.query.action === 'updated' && this.props.route.path !== 'updated' ) {
				this.redirect = true;
				this.props.dispatch( replace( { pathname: pathToNewPosts() } ) );

			} else if( this.props.searchresult.query.action === 'latest' && this.props.route.path !== 'latest' ) {
				this.redirect = true;
				this.props.dispatch( replace( { pathname: pathToActiveTopics() } ) );

			} else if( this.props.searchresult.query.action === 'participated' && this.props.route.path !== 'participated' ) {
				this.redirect = true;
				this.props.dispatch( replace( { pathname: pathToParticipated() } ) );

			} else if(
				( !this.props.searchresult.query.action || this.props.searchresult.query.action === 'search' ) &&
				(
					parseInt( this.props.routeParams.searchId ) !== parseInt( this.props.searchresult.searchId ) ||
					this.props.location.query.q !== this.props.searchresult.query.searchQuery ||
					parseInt( this.props.location.query.showposts ) !== parseInt( this.props.searchresult.query.showposts ) ||
					parseInt( this.props.location.query.forumid ) !== parseInt( this.props.searchresult.query.forumId )
				)
			) {
				let query = {
					q: this.props.searchresult.query.searchQuery,
					showposts: this.props.searchresult.query.showposts
				};
				if( this.props.searchresult.query.forumId !== null ) {
					query.forumid = this.props.searchresult.query.forumId;
				}
				if( this.props.location.query.page ) {
					query.page = this.props.location.query.page;
				}

				this.redirect = true;

				this.props.dispatch( replace( {
						pathname: pathToSearch( this.props.searchresult.searchId ),
						query: query
					} )
				);
			}

			this.repositionScroll();

			// Stuff to trigger once per search, not on every page
			if(
				this.props.searchresult.query.action === 'search' &&
				this.props.searchresult.query.searchQuery &&
				parseInt( prevProps.searchresult.searchId ) !== parseInt( this.props.searchresult.searchId )
			) {
				// Captify needs to be triggered once per search
				triggerCaptify( this.props.searchresult.query.searchQuery );

				// Record the Google Analytics event per search
				let isForumSearch = this.props.searchresult.query.forumid ? 1 : 0;
				this.props.dispatch( trackGAEvent( false, 'search', 'userAction', 'consumption', isForumSearch ) );
			}
		}
	}

	_resetStore() {
		this.props.dispatch( resetForum() );
		this.props.dispatch( resetThread() );
		this.props.dispatch( resetSearch() );
		this.props.dispatch( resetInfinite() );
	}

	prepareSearchRequest = ( props ) => {
		let id = 'search',
			page = props.location.query.page || 1,
			showposts = 0,
			showtopics = null;

		switch( props.route.path ) {
			case 'latest':
				id = 'new';
				break;

			case 'following':
				id = 'fav';
				showtopics = props.location.query.showtopics || 1;
				break;

			case 'participated':
				id = 'part';
				break;

			case 'updated':
				id = 'unread';
				break;

			default:
				showposts = props.location.query.showposts || 0;
				break;
		}

		let searchRequest = {
			id: id,
			showtopics: showtopics,
			showposts: showposts,
			page: page
		};

		if( id === 'search' ) {
			searchRequest.searchQuery = props.location.query.q;
			searchRequest.forumId = ( props.location.query.forumid || null );
			searchRequest.searchId = props.routeParams.searchId;
		}

		return searchRequest;
	};

	dispatchSearch = ( props ) => {
		let searchRequest = this.prepareSearchRequest( props );
		this.props.dispatch( fetchSearch( searchRequest ) );
	};

	toggleSubscribeType( subType ) {
		let query = this.props.location.query,
			pathname = this.props.location.pathname;

		query.showtopics = parseInt( subType );
		query.page = 1;

		this.props.dispatch( replace( {
			pathname: pathname,
			query: query
		} ) );
	}

	loadPage = ( page, forceRefresh ) => {
		let searchRequest = this.prepareSearchRequest( this.props );
		searchRequest.page = page;
		searchRequest.forceRefresh = forceRefresh;

		this.props.dispatch( fetchSearch( searchRequest ) );
	};

	repositionScroll = () => {
		if( this.header ) {
			let headerDim = this.header.getBoundingClientRect();

			if( !isNaN( headerDim.height ) && headerDim.height !== this.state.headerHeight ) {
				this.setState( { headerHeight: headerDim.height } );
			}
		} else {
			this.setState( { headerHeight: 0 } );
		}
	};

	resultsHeader() {
		return <header className="thread" ref={ ( h ) => this.header = h }>{ this._createHeaderContent() }</header>;
	}

	_createHeaderContent() {
		let { loaded, isFetching, result } = this.props.searchresult;

		if ( loaded && !isFetching && result.posts.length <= 0 && result.topics.length <= 0 && result.forums.length <= 0 ) {
			switch( this.props.searchresult.query.action ) {
				case 'latest':
					return <div className="details">There are no recently active topics.</div>;
				case 'updated': // updated
					return <div className="details">There are no new posts.</div>;
				case 'fav': // following and/or subscribed and/or favorite
					return [
								this.subHeaderSelector(),
								<div key="details" className="details">You are not subscribed to any { parseInt( this.props.searchresult.query.showtopics ) === 1 ? 'topics' : 'forums' }</div>
							];
				default:
					return [
						<div key="details" className="commonWords">There are no results for <span className="query">{ this.props.location.query.q }</span></div>,
						this.commonWords()
					];
			}
		}

		switch( this.props.route.path ) {
			case 'following':
				return this.subHeaderSelector();

			case 'latest':
			case 'participated':
			case 'updated':
				return null;
		}

		return <div className="details">Search results for: <span className="query">{ this.props.location.query.q }</span></div>;
	}

	subHeaderSelector() {
		let showTopic = parseInt( this.props.location.query.showtopics || this.props.searchresult.query.showtopics );
		return (
			<div key="subHeaderSelector" className='subheader-selector'>
				<div className={( showTopic === 1 ? 'active' : 'inactive')} onClick={ () => this.toggleSubscribeType(1) }>Topics</div>
				<div className={( showTopic === 0 ? 'active' : 'inactive')} onClick={ () => this.toggleSubscribeType(0) }>Forums</div>
			</div>
		);
	}

	commonWords() {
		return (
			this.props.searchresult.commonwords && this.props.searchresult.commonwords.length > 0 ?
			 (
				<div key="commonWords" className="commonWords">
					The following words were omitted from the search because they are too common or too short: <span className="query">{ this.props.searchresult.commonwords.join(',') }</span>
				</div>
			) : null
		);
	}

	searchResults() {
		let showLast = (
			this.props.searchresult && (
				this.props.searchresult.query.action === 'latest' ||
				this.props.searchresult.query.action === 'updated' ||
				this.props.searchresult.query.action === 'fav'
			)
		);

		if(
			parseInt( this.props.searchresult.query.showposts ) === 1 &&
			this.props.searchresult.result.posts.length > 0
		) {
			return <PostList threadview={ this.props.searchresult } isSearch={ true } />

		} else if ( this.props.searchresult.query.action === 'fav' ) {
			if( parseInt( this.props.searchresult.query.showtopics ) === 1 && this.props.searchresult.result.topics.length > 0 ) {
				return <ThreadList showLast={ showLast } />
			} else if( this.props.searchresult.result.forums.length > 0 ) {
				return <ForumList isScrolled={ true } />
			} else {
				return null;
			}

		} else if(
			(
				( this.props.searchresult && this.props.searchresult.query.action === 'latest' ) ||
				( this.props.searchresult && this.props.searchresult.query.action === 'updated' ) ||
				( this.props.searchresult && this.props.searchresult.query.action === 'participated' ) ||
				( this.props.searchresult && this.props.searchresult.query.showposts === 0 ) ||
				parseInt( this.props.location.query.showposts ) === 0
			) &&
			this.props.searchresult.result.topics.length > 0
		) {
			return <ThreadList isSearch={ ( parseInt( this.props.location.query.showposts ) === 0 ) } showLast={ showLast } />

		} else {
			return null;
		}
	}

	getAdUnit() {
		let showPosts = this.props.location.query.showposts ? parseInt( this.props.location.query.showposts ) : 0;
		if(
			this.props.location.query.q &&
			this.props.searchresult.query.action === 'search' &&
			(
				( showPosts === 1 && this.props.searchresult.result.posts.length > 0 ) ||
				( showPosts === 0 && this.props.searchresult.result.topics.length > 0 )
			)
		) {
			let searchProp = {
				isTop: true,
				page: 1,
				searchQuery: this.props.location.query.q
			};

			return <AdComponent key={ `In_Search_Ad_Top` } adType="0" adName={ 'In_Search_Ad_Top' } search={ searchProp } />;
		}

		return null;
	}

	render() {
		let { isFetching, loaded } = this.props.searchresult;

		if( !loaded ) {
			return ( <div className="search">{ this.resultsHeader() }<LoaderCss style={ { marginTop: this.state.headerHeight + 'px' } } /></div> );
		}

		return (
			<div className="search">
				{ this.resultsHeader() }
				<InfiniteScroll
					scrollRef={ i => this.infiniteScroll = i }
					isFetching={ isFetching }
					loadPage={ this.loadPage }
					location={ this.props.location }
					extraHeaderHeight={ this.state.headerHeight }
				>
					{ this.getAdUnit() }
					{ this.searchResults() }
				</InfiniteScroll>
			</div>
		);
	}
}

export default connect( searchResultSelector )( SearchViewComponent );


// WEBPACK FOOTER //
// ./src/components/SearchViewComponent.js